import { __rest } from "tslib";
import React from "react";
var NUTRITIONAL_HEALTH_SLUGS = ["food-sensitivity-test", "food-sensitivity-comprehensive-test", "vitamin-d-test", "metabolism-test", "vitamin-d-and-inflammation-test", "food-allergy-test", "celiac-disease-test"],
    VITAMINS_AND_SUPPLEMENTS_SLUGS = ["vitamin-d3-2000-iu", "vitamin-b6-50-mg", "vitamin-b12-500-mcg", "omega-3-fish-oil-1000-mg"];
export var getNutritionalProducts = function getNutritionalProducts(t) {
  return t.filter(function (t) {
    return NUTRITIONAL_HEALTH_SLUGS.includes(t.slug);
  });
};
export var getVitaminsProducts = function getVitaminsProducts(t) {
  return t.filter(function (t) {
    return VITAMINS_AND_SUPPLEMENTS_SLUGS.includes(t.slug);
  });
};
export var CustomRenderAsLinkMock = function CustomRenderAsLinkMock(t) {
  var e = t.href,
      i = t.children,
      s = __rest(t, ["href", "children"]);

  return React.createElement("a", Object.assign({}, s, {
    href: e
  }), i);
};